import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseRequestMID } from "../utils/Classes/Requests/BaseRequestMID";
import { config } from "../utils/Constants";
import axios from "axios";
import {BaseRequest} from "../utils/Classes/Requests/BaseRequest";

const initialState = {
  employees: [],
  employeesAvatars: [],
  positions: [],
  oldPositions: [],
  branches: [],
  loading: "idle",
  avatarLoading: "idle",
  successMessage: "",
  error: null,
  avatarError: null
};

const URL = config.url;

export const fetchEmployees = createAsyncThunk(
  "Employee/GetEmployees",
  async () => {
    const req = new BaseRequest(
        sessionStorage.getItem("SessionID"),
    );
    const res = await axios.post(
      `${URL}/v1/PortalEmployee/GetBranchesEmployees`,
      req,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("Token"),
        }
      }
    );
    return res.data;
  }
);

export const fetchEmployeesAvatars = createAsyncThunk(
  "Employees/GetEmployeesAvatars",
  async () => {
    const req = new BaseRequest(
        sessionStorage.getItem("SessionID")
    );
    const res = await axios.post(
      `${URL}/v1/PortalEmployee/GetEmployeesAvatars`,
      req,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("Token"),
        }
      }
    );
    return res.data;
  });

const employeesSlice = createSlice({
  name: "employees",
  initialState,
  reducers: {
    // TODO: Reducers for employees UI, such as edit or delete
    addEmployee: (state, action) => {
      state.employees = [...state.employees, action.payload];
    },
    setEmployeesError: (state, action) => {
      state.error = action.payload;
    },
    setSuccessMessage: (state, action) => {
      state.successMessage = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchEmployees.pending, (state) => {
      if (state.loading === "idle") {
        state.loading = "pending";
      }
    });
    builder.addCase(fetchEmployees.fulfilled, (state, action) => {
      if (state.loading === "pending") {
        state.loading = "idle";
        state.employees = [...action.payload.Payload.merchantEmployees];
        state.positions = [...action.payload.Payload.Positions];
        // state.oldPositions = [...action.payload.Payload.OldPositions];
        state.branches = [...action.payload.Payload.Branches];
      }
    });
    builder.addCase(fetchEmployees.rejected, (state, action) => {
      if (state.loading === "pending") {
        state.loading = "idle";
        state.employees = [];
        state.positions = [];
        state.oldPositions = [];
        state.branches = [];
        state.error = action.error;
      }
    });

    // Employees Avatars
    builder.addCase(fetchEmployeesAvatars.pending, (state) => {
      if (state.avatarLoading === "idle") {
        state.avatarLoading = "pending";
      }
    });
    builder.addCase(fetchEmployeesAvatars.fulfilled, (state, action) => {
      if (state.avatarLoading === "pending") {
        state.avatarLoading = "idle";
        state.employeesAvatars = [...action.payload.Payload.EmployeeAvatars];
      }
    });
    builder.addCase(fetchEmployeesAvatars.rejected, (state, action) => {
      if (state.avatarLoading === "pending") {
        state.avatarLoading = "idle";
        state.avatarError = action.error;
      }
    });
  },
});

export const { setEmployeesError, setLoading } = employeesSlice.actions;

export default employeesSlice.reducer;
